import { MemoizedSelector, createFeatureSelector, createSelector } from "@ngrx/store";

import { AuditLogStoreState } from "../reducers/audit-log.reducers";

export const selectAuditLogStoreState: MemoizedSelector<AuditLogStoreState, AuditLogStoreState> =
    createFeatureSelector<AuditLogStoreState>("audit-log");

/**
 * get all of the audit log types
 *
 * @returns audit type store state
 */
export const getAllAuditTypes = () => createSelector(selectAuditLogStoreState, (state: AuditLogStoreState) => state?.auditType);

/**
 * get all of the audit log types
 *
 * @returns audit type store state
 */
export const getAudits = () => createSelector(selectAuditLogStoreState, (state: AuditLogStoreState) => state.auditData);
